export default {
    data: () => ({
        translations: {
            createWebhook: {
                el: "Δημιουργία Webhook",
                en: "Create Webhook",
                it: "Creare Webhook"
            },
            updateWebhook: {
                el: "Ενημέρωση Webhook",
                en: "Update Webhook",
                it: "Aggiornamento Webhook"
            },
            
            description: {
                el: "Περιγραφή",
                en: "Description",
                it: "Descrizione"
            },

            enabled: {
                el: "Eνεργοποιημένο",
                en: "Enabled",
                it: "Abilitato"
            },

            createdAt: {
                el: "Ημ/νία δημιουργίας",
                en: "Creation Date",
                it: "Data di creazione"
            },
            
            authorization: {
                el: "Εξουσιοδότηση",
                en: "Authorization",
                it: "Autorizzazione"
            },
            
            eventTypes: {
                el: "Συμβάντα",
                en: "Events",
                it: "Eventi"
            },
            actions : {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            disable : {
                el: "Απενεργοποίηση",
                en: "Disable",
                it: "Disattivare"
            },
            enable : {
                el: "Ενεργοποίηση",
                en: "Enable",
                it: "Abilitazione"
            },
            edit : {
                el: "Επεξεργασία",
                en: "Edit",
                it: "Modifica"
            },
            enableAuth : {
                el: "Ενεργοποίηση εξουσιοδότησης",
                en: "Enable Authorization",
                it: "Abilitazione dell'autorizzazione"
            },
            eventsSelected : {
                el: "Επιλεγμένα συμβάντα",
                en: "Events selected",
                it: "Eventi selezionati"
            },
            enableOnSave: {
                el: "Ενεργοποίηση webhook κατά την αποθήκευση",
                en: "Enable event webhook on save",
                it: "Abilita il webhook dell'evento sul salvataggio"
            },
            status: {
                el: "Κατάσταση",
                en: "Status",
                it: "Stato"
            },
            viewLogs: {
                el: "Προβολή αρχείων καταγραφής",
                en: "View logs",
                it: "Visualizza i log"
            },
            logs: {
                el: "Αρχεία καταγραφής",
                en: "Logs",
                it: "Log"
            },
            
            save: {
                el: "Αποθηκευση",
                en: "Save",
                it: "Risparmiare"
            },
            cancel: { 
                el: 'Ακύρωση', 
                en: 'Cancel', 
                it: 'Cancella' 
            },
            addEvents: { 
                el: 'Προσθήκη', 
                en: 'Add Events', 
                it: 'Aggiungi eventi' 
            },
            selectEventsToListen: {
                el: 'Select events to listen to', 
                en: 'Select events to listen to', 
                it: 'Selezionare gli eventi da ascoltare' 
            },
            selectEvents: {
                el: 'Επιλέξτε events', 
                en: 'Select events', 
                it: 'Selezionare gli eventi' 
            },
            editEvents: {
                el: 'Επεξεργασία events', 
                en: 'Edit events', 
                it: 'Modifica eventi' 
            },
            selected: { 
                el: 'Επιλεγμένα', 
                en: 'Selected', 
                it: 'Selezionato' 
            },
            selectAll: {
                el: "Επιλογή Όλων",
                en: "Select All",
                it: "Selezione di Tutti"
            },
            responseStructure: {
                el: 'Δομή', 
                en: 'Response Structure', 
                it: 'Struttura di risposta' 
            },
            responseMapping: { 
                el: 'Χαρτογράφηση', 
                en: 'Response Mapping', 
                it: 'Mappatura delle risposte' 
            },
            logsData: { 
                el: 'Δεδομένα καταγραφής του Webhook', 
                en: 'Webhook Log Data', 
                it: 'Dati di registro Webhook' 
            },
            mappingDescription: {
                el: 'Μπορείτε να ορίσετε το webhook response για κάθε μία από τις παρακάτω κατηγορίες συμβάντων. Ελέγξτε τις διαθέσιμες ιδιότητες στα αριστερά και χρησιμοποιήστε αυτές που θέλετε να συμπεριληφθούν στο response σας, προσθέτοντάς τες στον επεξεργαστή json που είναι διαθέσιμος παρακάτω. Εάν το response παραμείνει κενό, τότε όλες οι διαθέσιμες ιδιότητες θα αποσταλούν με την προεπιλεγμένη μορφή.', 
                en: 'You can set up your webhook response for each of the event categories below. Check the available properties at the left and use the ones you want included in your response, by adding them in the json editor available below. If the response is left empty, then all the available properties will be sent at the default format.', 
                it: "È possibile impostare la risposta del webhook per ciascuna delle categorie di eventi riportate di seguito. Controllare le proprietà disponibili a sinistra e utilizzare quelle che si desidera includere nella risposta, aggiungendole nell'editor json disponibile in basso. Se la risposta viene lasciata vuota, tutte le proprietà disponibili saranno inviate nel formato predefinito." 
            },
            confirmPurchase1: { 
                el: 'Είστε σίγουροι ότι θέλετε να αγοράσετε ', 
                en: 'Are you sure you want to purchase ', 
                it: 'Siete sicuri di voler acquistare ' 
            },
            confirmPurchase2: { 
                el: ' του προϊόντος ', 
                en: ' of the product ', 
                it: ' del prodotto ' 
            },
            confirmPurchase3: { 
                el: ' με SKU: ', 
                en: ' with SKU: ', 
                it: ' con SKU: ' 
            },
            confirmPurchase3t: { 
                el: 'όριο: ', 
                en: 'threshold: ', 
                it: 'soglia: ' 
            },
            confirmPurchase4: { 
                el: ' και τιμή: ', 
                en: ' and price: ', 
                it: ' e prezzo: ' 
            },
            availableOptions: { 
                el: 'Διαθέσιμες επιλογές', 
                en: 'Available options', 
                it: 'Opzioni disponibili' 
            },
            productType: { 
                el: 'Τύπος προϊόντος', 
                en: 'Product Type', 
                it: 'Tipo di prodotto' 
            },
            price: { 
                el: 'Τιμή', 
                en: 'Price', 
                it: 'Prezzo' 
            },
            hasThreshold: { 
                el: 'Θέλω να προσθέσω ένα όριο σε αυτή την αγορά', 
                en: 'I want to add a threshold to this purchase', 
                it: 'Voglio aggiungere una soglia a questo acquisto' 
            },
            thresholdLabel: { 
                el: 'Εισάγετε το όριο', 
                en: 'Type the threshold', 
                it: 'Digitare la soglia' 
            },
            confirmPurchaseTitle: { 
                el: 'Επιβεβαίωση αγοράς', 
                en: 'Confirm Purchase', 
                it: "Confermare l'acquisto"
            },
            purchase: {
                el: 'Αγορά',
                en: 'Purchase',
                it: 'Acquisto'
            },
            purchaseSuccess: { 
                el: 'Έχετε αγοράσει επιτυχώς το προϊόν  ', 
                en: 'You have successfuly purchased product ', 
                it: 'Avete acquistato con successo il prodotto ' 
            },
            purchaseError: { 
                el: 'Προέκυψε σφάλμα κατά την αγορά του προϊόντος.', 
                en: 'An error occured while purchasing the product.', 
                it: "Si è verificato un errore durante l'acquisto del prodotto." 
            },
            image: {
                el: "Εικόνα",
                en: "Image",
                it: "Immagine"
            },  
            addProduct: {
                el: "Προσθήκη Προϊόντος",
                en: "Add Product",
                it: "Aggiungi prodotto"
            },
            add: {
                el: "Προσθήκη",
                en: "Add",
                it: "Aggiungi"
            },
            productName: {
                el: "Όνομα Προϊόντος",
                en: "Product Name",
                it: "Nome del prodotto"
            },
            productDescription: {
                el: "Περιγραφή Προϊόντος",
                en: "Product Description",
                it: "Descrizione del prodotto"
            },
            sellingPrice: {
                el: "Τιμή Πώλησης",
                en: "Selling Price",
                it: "Prezzo di vendita"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            create: {
                el: "Προσθήκη",
                en: "Add",
                it: "Aggiungi"
            },
            update: {
                el: "ΕΝΗΜΕΡΩΣΗ",
                en: "UPDATE",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            productNameModal: {
                el: "Ονομασία Προϊόντος",
                en: "Product Name",
                it: "Nome del prodotto"
            },
            productDescriptionModal: {
                el: "Περιγραφή Προϊόντος",
                en: "Product Description",
                it: "Descrizione del prodotto"
            },
            sellingPriceModal: {
                el: "Τιμή Πώλησης",
                en: "Selling Price",
                it: "Prezzo di vendita "
            },
            productImageOptional: {
                el: "Εικόνα προϊόντος (προαιρετικό)",
                en: "Product Image (optional)",
                it: "Immagine del prodotto (opzionale)"
            },
            publish: {
                el: "Δημοσίευση",
                en: "Publish",
                it: "Pubblicazione" 
            },
            deleteConfirmationMessage: {
                el: "Σίγουρα θέλεις να διαγράψεις το ",
                en: "Are you sure you want to delete ",
                it: "Siete sicuri di voler eliminare "
            },
            questionmark: {
                el: " ;",
                en: " ?",
                it: " ?"
            },
            deleteProduct: {
                el: "Διαγραφή Προϊόντος",
                en: "Delete Product",
                it: "Eliminare il prodotto"
            },
            variants: {
                el: "παραλλαγές",
                en: "Variants",
                it: "Varianti"
            },
            createProductTitle: {
                el: "Νέο Προϊόν ή Υπηρεσία",
                en: "New Product or Service",
                it: "Nuovo prodotto o servizio"
            },
            
            updateProductTitle: {
                el: "Επεξεργασία Προϊόντος ή Υπηρεσίας",
                en: "Edit Product or Service",
                it: "Modifica prodotto o servizio"
            },
            all: {
                el: "Όλα",
                en: "All",
                it: "Tutti" 
            },
            storesSelected: {
                el: "Επιλεγμένες Εταιρίες",
                en: "Companies Selected",
                it: "Negozi selezionati" 
            },
            companies: {
                el: "Εταιρίες",
                en: "Companies",
                it: "Negozi" 
            },
            attribute:{
                el: "Ιδιότητα",
                en: "Attribute",
                it: "Attributo" 
            },
            attributeOptions: { 
                el: 'Επιλογές ιδιοτήτων', 
                en: 'Attribute options', 
                it: 'Opzioni di attributi' 
            },
            inventory:{
                el: "Aπόθεμα",
                en: "Inventory",
                it: "Stock" 
            },
            creditType:{
                el: "Τύπος πίστωσης",
                en: "Credit Type",
                it: "Tipo di credito" 
            },
            creditOption:{
                el: "Επιλογή πίστωσης",
                en: "Credit Option",
                it: "Opzione credito" 
            },
            
            loadMore: {
                el: "Φόρτωση περισσότερων...",
                en: "Loading More...",
                it: "Per saperne di più..." 
            },
            
            variantsSelected: {
                el: "Επιλεγμένες παραλλαγές",
                en: "Companies variants",
                it: "Negozi varianti" 
            },
            show: {
                el: "Εμφάνιση",
                en: "Show",
                it: "Mostrare" 
            },
        }
    })
};
